import styled from 'styled-components'
import { Icon } from 'ui/components'

const Title = styled.div`
  font-weight: normal;
  margin: 19px 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  > a {
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    text-decoration: none;
  }

  > i {
    flex-shrink: 0;
  }

  > h1 {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const Arrow = styled(Icon)`
  margin: 0 20px;
  opacity: 0.3;
  position: relative;
  line-height: 26px;
  font-size: 26px;
`

export const s = { Title, Arrow }
